import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const NcDmvService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/ncdmv`;

  const getNcDmvRenewalsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/renewal/search${queryString}`, {
      headers,
    });
  };

  const getNcDmvPendingRenewalsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/pending-renewal/search${queryString}`, {
      headers,
    });
  };

  service.getNcDmvRenewalsBySearchCriteria = getNcDmvRenewalsBySearchCriteria;
  service.getNcDmvPendingRenewalsBySearchCriteria = getNcDmvPendingRenewalsBySearchCriteria;

  return service;
})();

export default NcDmvService;
